import * as React from 'react';

import * as S from './styles';

interface Props {
    leftButtons?: JSX.Element[];
    filters?: JSX.Element[];
    filtersButtons?: JSX.Element[];
    rightButtons?: JSX.Element[];
}

export const TableFiltersBar: React.FunctionComponent<Props> = ({
    leftButtons,
    filters,
    filtersButtons,
    rightButtons,
}) => (
    <S.FiltersBarWrapper>
        <div>
            {leftButtons && (
                <S.LeftButtons>
                    {leftButtons.map((Button, i) => (
                        <React.Fragment key={i}>{Button}</React.Fragment>
                    ))}
                </S.LeftButtons>
            )}
            {filters && (
                <S.Filters>
                    {filters.map((Filter, i) => (
                        <S.FilterWrapper key={i}>{Filter}</S.FilterWrapper>
                    ))}
                </S.Filters>
            )}
            {filtersButtons && (
                <S.FiltersButtons>
                    {filtersButtons.map((Button, i) => (
                        <React.Fragment key={i}>{Button}</React.Fragment>
                    ))}
                </S.FiltersButtons>
            )}
            {rightButtons && (
                <S.RightButtons>
                    {rightButtons.map((Button, i) => (
                        <React.Fragment key={i}>{Button}</React.Fragment>
                    ))}
                </S.RightButtons>
            )}
        </div>
    </S.FiltersBarWrapper>
);
